import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-950 px-6 py-16 text-center">
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-1/2 top-1/2 h-80 w-80 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-500/10 blur-3xl" />
      </div>

      <span className="font-heading text-7xl font-bold text-primary-500/20 md:text-8xl">
        404
      </span>

      <h1 className="mt-4 text-[2rem] font-bold leading-[1.3] md:text-[2.75rem]">
        找不到這個頁面。
      </h1>

      <p className="mx-auto mt-4 max-w-md text-[1.1875rem] leading-[1.75] text-foreground-300">
        你可以回到 keepvox 首頁，或前往支援中心。
      </p>

      <div className="mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-base font-semibold text-background-950 transition-colors hover:bg-primary-400"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首頁
        </Link>
        <Link
          to="/support"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-200/30 px-6 py-3.5 text-base font-medium text-foreground-100 transition-colors hover:border-primary-400 hover:text-primary-300"
        >
          <i className="ri-customer-service-2-line" aria-hidden="true"></i>
          支援中心
        </Link>
      </div>
    </div>
  );
}